var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeedway({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m24.21 29.074 3.726 2.295c3.208.194 8.635-.662 11.597-3.352-.784 5.074-2.602 10.005-4.67 14.9-5.673 4.095-10.404 6.513-14.094 7.083l.245-.042-.002.042-.123-.02-.12.02-.004-.042-.081-.013c-3.642-.658-8.26-3.054-13.766-7.027-2.069-4.896-3.886-9.827-4.67-14.9 2.962 2.69 8.388 3.545 11.597 3.351l3.726-2.295 6.638 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E47633",
    d: "m24.225 29.085.233.143 0 19.73c-1.199.469-2.32.799-3.36.987l-.084.014-.002.041-.12-.021-.123.021.121-.021-.121.021-.004-.042-.081-.013c-1.042-.188-2.163-.519-3.362-.987l0-19.73.233-.143 6.67 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E47633",
    d: "m24.225 29.085.233.143 0 19.73c-1.199.469-2.32.799-3.36.987l-.084.014-.002.041-.12-.021-.123.021.121-.021-.121.021-.004-.042-.081-.013c-1.042-.188-2.163-.519-3.362-.987l0-19.73.233-.143 6.67 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20.89 3.022c2.905 0 2.362-1.251 4.755-.924 7.415 1.393 11.873 5.409 13.375 12.045-12.388 1.283-24.502 1.398-36.26 0 2.243-6.544 6.464-10.51 12.662-11.899 2.666-.524 2.563.778 5.468.778Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.024.085c8.194 1.54 13.308 6.146 14.996 13.607l.509 2.25-2.298.238c-12.96 1.341-25.154 1.37-36.712-.003l-2.519-.3.821-2.396c2.468-7.202 7.24-11.686 14.204-13.245 1.496-.295 2.511-.19 3.686.254.101.039.41.16.439.171.588.228.989.313 1.74.313.766 0 1.07-.074 1.464-.272.047-.023.253-.13.307-.157.992-.5 1.893-.663 3.363-.46Zm-.379 2.013c-2.393-.327-1.85.924-4.755.924-2.905 0-2.802-1.302-5.468-.778-6.198 1.388-10.419 5.355-12.661 11.9 11.757 1.397 23.87 1.282 36.259 0-1.502-6.637-5.96-10.653-13.375-12.046Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E47633",
    d: "m24.459 2.075 0 13.02c-2.391.06-4.77.07-7.137.027l0-12.922c1.01.22 1.595.822 3.568.822 2.29 0 2.438-.777 3.569-.947Zm-11.197.785 0 12.134c-2.393-.107-4.772-.27-7.138-.493l0-6.64c1.877-2.32 4.257-3.988 7.138-5Zm22.394 4.413 0 7.19c-2.39.207-4.77.369-7.137.483l0-12.13c2.981.952 5.36 2.438 7.137 4.457Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E47633",
    d: "m24.459 2.075 0 13.02c-2.391.06-4.77.07-7.137.027l0-12.922c1.01.22 1.595.822 3.568.822 2.29 0 2.438-.777 3.569-.947Zm-11.197.785 0 12.134c-2.393-.107-4.772-.27-7.138-.493l0-6.64c1.877-2.32 4.257-3.988 7.138-5Zm22.394 4.413 0 7.19c-2.39.207-4.77.369-7.137.483l0-12.13c2.981.952 5.36 2.438 7.137 4.457Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m2.815 14.003 1.828-.457-.528 1.637c-1.107 3.933-1.225 7.85-.388 12.127l.892 2.647-2.283-1.576-.151-.77c-.883-4.513-.758-8.677.417-12.852l.213-.756Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m38.343 14.003 1.828-.457-.527 1.637c-1.107 3.933-1.226 7.85-.388 12.127l.891 2.647-2.283-1.576-.15-.77c-.884-4.513-.758-8.677.417-12.852l.212-.756Z",
    transform: "matrix(-1 0 0 1 77.308 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedway);
export default __webpack_public_path__ + "static/media/speedway.ae953af3488a26ee6a820cb87ed0456d.svg";
export { ForwardRef as ReactComponent };